// This file is auto-generated by @skynet/data-helpers/scripts/generate-rtk-exports.mjs
// Do not edit manually.

import { hookExports } from './dex-add-vaults-api';

export const useGetQuoteTokens: typeof hookExports.useGetQuoteTokens =
  hookExports.useGetQuoteTokens;
export const useLazyGetQuoteTokens: typeof hookExports.useLazyGetQuoteTokens =
  hookExports.useLazyGetQuoteTokens;
export const useFormatTokenAddress: typeof hookExports.useFormatTokenAddress =
  hookExports.useFormatTokenAddress;
export const useLazyFormatTokenAddress: typeof hookExports.useLazyFormatTokenAddress =
  hookExports.useLazyFormatTokenAddress;
export const useGetTokenDetails: typeof hookExports.useGetTokenDetails =
  hookExports.useGetTokenDetails;
export const useLazyGetTokenDetails: typeof hookExports.useLazyGetTokenDetails =
  hookExports.useLazyGetTokenDetails;
export const useGetPool: typeof hookExports.useGetPool = hookExports.useGetPool;
export const useLazyGetPool: typeof hookExports.useLazyGetPool = hookExports.useLazyGetPool;
export const useGenerateAddress: typeof hookExports.useGenerateAddress =
  hookExports.useGenerateAddress;
export const useLazyGenerateAddress: typeof hookExports.useLazyGenerateAddress =
  hookExports.useLazyGenerateAddress;
